import React from 'react'

const IconUser = ({ fill = 'black', width = 18, height = 23 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='70' height='75' viewBox='0 0 70 75' fill='none'>
      <path
        d='M55.7772 23.6986C53.9119 25.24 53.0839 27.9424 53.8634 30.2614C53.1709 30.9058 52.706 31.7976 52.5312 32.7392C51.9963 31.8374 51.4091 30.9675 50.7724 30.1345C51.0831 29.1282 51.1209 28.0604 50.7336 27.0399C50.0031 25.2738 48.0087 24.3546 46.1482 24.4952C45.8025 24.5151 45.4592 24.5598 45.1191 24.6256C42.3181 22.5997 39.1303 21.1238 35.7367 20.3786C34.8142 18.983 32.9812 18.6214 31.4332 18.4225C30.7491 18.1708 30.012 18.0884 29.2833 18.1053C27.5518 18.0789 25.8122 18.4722 24.3102 19.3142C23.0548 19.7205 21.7095 20.3632 20.7856 21.3443C17.2593 22.7132 14.0337 24.8776 11.4175 27.5969C7.43886 31.5505 4.44711 36.4292 2.38055 41.6285C3.65446 43.0864 5.42519 43.8176 7.27972 44.2755C4.85201 47.7537 2.98181 51.6671 2.09159 55.8179C1.05651 56.9354 0.369815 58.3549 0.283534 59.9064C0.225668 61.8179 1.57222 63.6385 3.44152 64.0865C5.34082 64.6333 7.35788 64.1907 8.9892 63.1348C9.42857 63.1973 9.8627 63.2757 10.2756 63.4168C11.5922 63.6739 12.9078 63.9331 14.2231 64.1957C14.6726 65.6882 15.7625 67.2024 17.4199 67.3255C18.3287 67.355 19.1514 66.8428 19.7003 66.1447C19.9221 66.7757 20.1452 67.4063 20.3664 68.0374C21.0677 68.2106 21.7752 68.3566 22.4882 68.478C22.91 70.2558 23.3285 72.0354 23.7464 73.8141C27.599 75.3503 32.2581 75.5912 35.8922 73.37C36.7806 72.8865 37.6412 72.3392 38.4299 71.7064C38.4925 70.0544 38.558 68.4027 38.6273 66.7508C39.4148 66.4275 40.1884 66.0687 40.9429 65.6723C41.6097 65.2349 41.3011 64.2552 41.5103 63.5788C42.1387 58.399 42.7182 53.2125 43.3114 48.028C43.61 47.8806 43.9074 47.7302 44.2031 47.5768C44.2277 47.8016 44.2652 48.0263 44.3159 48.25C44.9063 52.19 49.3652 54.997 53.166 53.7589C57.0889 52.7434 59.4184 47.8683 57.695 44.1756C57.5391 43.793 57.3442 43.4285 57.1205 43.083C58.1915 41.6441 59.2732 40.2163 60.3208 38.7584C60.5687 38.7153 60.8129 38.6591 61.0539 38.5892C62.8216 38.0221 64.36 36.4452 64.5008 34.5606C67.384 34.365 68.3987 33.0903 69.5165 30.5703C69.7979 29.9276 69.8888 28.9084 69.8888 28.9084C70.2299 28.4716 69.6847 27.6243 69.6049 26.8915C69.5288 26.1929 68.9095 25.8345 68.8026 25.4108C68.5626 24.4598 68.8675 23.8062 68.7395 23.014C68.1879 22.0571 65.1765 26.6543 62.7212 26.0993C61.2239 25.7608 65.1651 23.7525 65.6037 23.0206C66.7017 21.1884 66.5534 19.9124 66.3681 19.6059C63.0628 14.1391 61.0601 21.5386 55.7777 23.6978L55.7772 23.6986ZM53.0634 35.7103C53.0749 35.728 53.0868 35.7456 53.0986 35.7631C52.471 37.0202 51.8227 38.2712 51.1989 39.5308C50.9315 38.815 50.6641 38.0997 50.3953 37.3844C51.1759 36.921 51.9437 36.4348 52.6968 35.9252C52.8372 35.876 52.9587 35.8023 53.0634 35.7103ZM11.5584 48.0885C11.8632 49.102 12.1755 50.113 12.5136 51.1161C13.2213 51.4254 13.9427 51.6982 14.6741 51.9373C15.0803 53.0813 15.4841 54.226 15.89 55.3702C15.0734 55.808 14.4171 56.5246 14.156 57.4321C13.5298 57.4164 12.9035 57.3973 12.2774 57.3827C12.1646 55.9997 11.3597 54.6973 10.1415 54.0168C10.5273 52.0129 10.8376 49.9745 11.5583 48.0885L11.5584 48.0885Z'
        fill='black'
      />
      <path
        d='M37.8874 65.5638C33.24 68.1957 27.7443 68.5764 22.6636 67.2781C23.1532 69.3487 23.6445 71.4189 24.1314 73.4902C27.7791 74.838 31.9455 75.1308 35.401 73.1261C36.3091 72.6571 37.164 72.1231 37.9864 71.4913C38.0651 69.4548 38.1443 67.4186 38.2325 65.3828C38.1175 65.4431 38.0025 65.5034 37.8875 65.5637L37.8874 65.5638Z'
        fill='black'
      />
      <path
        d='M37.7124 66.7266C33.2883 69.1272 28.4156 69.3574 23.418 68.517L24.5048 73.0741C24.5048 73.0741 28.0651 74.4348 31.4624 73.9414C34.5863 73.4878 37.5424 71.1933 37.5424 71.1933L37.7124 66.7266Z'
        fill='#969696'
      />
      <path
        d='M37.7409 66.6953C34.5661 68.0625 31.1294 68.8674 27.6963 68.9541C27.9315 69.1294 28.1309 69.3072 28.2755 69.4874C29.2274 70.6739 29.7253 72.3512 29.7253 72.3512C29.7253 72.3512 29.8427 68.6392 31.3647 69.0484C32.8868 69.4576 33.3365 72.4385 33.3365 72.4385C33.3365 72.4385 33.4796 69.0045 34.4098 69.086C35.34 69.1676 36.1597 72.0425 36.1597 72.0425L36.2588 72.0512C37.0488 71.5704 37.5425 71.1905 37.5425 71.1905L37.7409 66.6953Z'
        fill='url(#paint0_linear_10790_2687)'
      />
      <path
        d='M13.253 43.5613C13.7857 41.8468 13.2182 40.0333 11.7374 40.473C10.4827 40.6172 9.23003 42.0011 8.43297 43.4557C6.11805 46.5771 4.10404 50.1483 3.09675 53.8538C2.694 55.0375 2.34057 56.266 2.34427 57.3803C4.64475 56.9228 6.94411 56.4715 9.24291 56.0241C10.0396 52.8146 10.2372 49.499 11.8292 46.3323C12.3861 45.4558 13.0906 44.5778 13.2531 43.5611L13.253 43.5613Z'
        fill='black'
      />
      <path
        d='M8.80324 55.3727C8.80324 55.3727 9.80879 50.1942 10.471 48.1118C11.1333 46.0295 12.2173 44.8227 12.2173 44.8227C12.2173 44.8227 13.0226 43.2537 12.7589 41.8918C12.4952 40.5299 10.2517 41.4238 9.5592 42.712C8.86671 44.0003 6.09296 47.1934 4.67299 50.9795C2.97026 55.5197 2.98707 56.5131 2.98707 56.5131L8.80324 55.3727Z'
        fill='#FF9900'
      />
      <path
        d='M12.1239 43.542C12.4086 42.6087 12.4168 41.9834 11.5996 42.052C10.9443 42.107 8.89558 45.6686 8.20331 47.0662C7.18643 49.119 5.54472 51.9547 4.67041 55.3501C5.47698 55.1627 8.19643 54.8379 8.4494 54.3547C8.27151 50.5036 10.8794 45.8263 12.1239 43.542Z'
        fill='url(#paint1_linear_10790_2687)'
      />
      <path
        d='M42.7045 45.9085C37.5411 48.4422 31.9445 50.2247 26.1825 50.9452C22.2117 51.3458 18.1719 50.9911 14.3896 49.7734C16.4993 55.7333 18.6095 61.6926 20.712 67.6545C27.1137 69.2678 35.0515 68.4042 40.8487 65.2128C41.4202 60.7477 42.4775 51.2533 43.123 45.7031C42.9834 45.7716 42.8437 45.84 42.7041 45.9085L42.7045 45.9085Z'
        fill='black'
      />
      <path
        d='M42.5162 46.5547C39.0935 48.239 35.4529 49.4902 31.7287 50.4085C26.3737 51.8737 20.5309 52.0565 15.1853 50.518L21.1089 67.2576C21.1089 67.2576 26.0858 68.6614 31.943 67.7631C37.8001 66.8647 40.3956 64.7656 40.3956 64.7656L42.5162 46.5547Z'
        fill='#3366FF'
      />
      <path
        d='M42.5164 46.5547C39.0937 48.239 35.4531 49.4902 31.7289 50.4085C29.8058 50.9347 27.8188 51.2929 25.8154 51.4679C32.8505 53.9442 38.1982 58.9149 40.2024 64.9052C40.3256 64.8191 40.3951 64.7654 40.3951 64.7654L42.5164 46.5547Z'
        fill='url(#paint2_linear_10790_2687)'
      />
      <path
        d='M46.9229 37.5376C36.201 42.2625 24.6467 43.4749 13.552 42.8599C12.461 42.7764 10.5577 42.6805 9.48315 42.5151C10.329 45.0446 11.6596 48.2591 12.5119 50.7858C19.5621 53.6444 25.7089 53.0324 32.2978 51.5065C36.5357 50.5252 40.6996 48.942 44.6388 46.8356C45.5472 43.6708 46.4575 40.5064 47.3758 37.3438C47.2247 37.4084 47.0735 37.473 46.9223 37.5376L46.9229 37.5376Z'
        fill='black'
      />
      <path
        d='M46.6239 38.2109C38.0589 41.9589 28.806 43.3683 19.8474 43.5425C16.9244 43.5438 13.9299 43.5542 11.0635 43.103L13.3503 50.3424C13.3503 50.3424 19.5047 53.3576 28.5978 51.782C37.6914 50.2064 44.2355 46.4997 44.2355 46.4997L46.6239 38.2109Z'
        fill='#FF9900'
      />
      <path
        d='M46.6233 38.2109C38.0584 41.9589 28.8054 43.3683 19.8469 43.5425C18.7367 43.543 17.6162 43.5429 16.4964 43.5202C16.2509 43.6083 16.0076 43.6972 15.7576 43.7889C30.0317 44.4379 39.8429 44.8151 44.2371 46.4916L46.6233 38.2109Z'
        fill='url(#paint3_linear_10790_2687)'
      />
      <path
        d='M31.2816 20.2257C25.1323 19.7427 18.609 21.7839 13.5664 26.2302C8.8806 30.2271 5.2753 35.6467 2.90918 41.5307C4.7442 43.4815 7.42059 44.3906 9.91235 44.861C16.3187 45.8016 22.9729 44.8819 29.493 44.0359C37.3943 42.836 45.389 40.3487 52.3647 35.5724C53.2198 35.2218 53.2021 34.6612 52.7168 34.035C48.3963 25.8512 40.1649 20.6181 31.2808 20.2256L31.2816 20.2257Z'
        fill='black'
      />
      <path
        d='M3.50488 41.3811C3.50488 41.3811 10.8448 21.4181 28.4282 20.7561C46.0115 20.094 52.5315 34.8147 52.5315 34.8147C52.5315 34.8147 42.8774 42.631 24.6905 44.0433C6.50271 45.4556 3.50601 41.3812 3.50601 41.3812L3.50488 41.3811Z'
        fill='#9CDAFB'
      />
      <path
        d='M31.5961 20.8061C30.5824 20.7347 29.5287 20.7142 28.4298 20.7556C28.2418 20.7626 28.0541 20.7733 27.8684 20.7847C35.0933 23.9274 39.5947 30.4375 38.6234 37.5492C38.4188 39.0477 37.9823 40.4832 37.3486 41.8328C47.3231 39.034 52.5307 34.8188 52.5307 34.8188C52.5307 34.8188 46.8005 21.879 31.5954 20.8064L31.5961 20.8061Z'
        fill='url(#paint4_linear_10790_2687)'
      />
      <path
        d='M26.2692 23.1054C18.0596 22.4602 8.75584 30.7809 5.15234 41.8391C7.41764 43.0416 10.0981 43.282 12.6489 43.5792C13.0651 43.6122 13.4825 43.6436 13.8997 43.6689C13.952 43.295 14.0133 42.9185 14.0809 42.5408C15.7467 33.2337 21.564 25.6906 28.1521 23.4214C27.5518 23.2627 26.9235 23.1567 26.2694 23.1053L26.2692 23.1054Z'
        fill='url(#paint5_linear_10790_2687)'
      />
      <path
        d='M43.9717 25.0065C40.6648 25.9231 38.4809 29.6778 39.0816 32.3156C39.4782 34.9647 42.9368 36.0893 46.0842 34.5741C49.2682 33.2151 51.6841 29.9084 50.6203 27.5493C49.8707 25.6379 46.56 24.2096 43.9718 25.0065H43.9717Z'
        fill='black'
      />
      <path
        d='M44.7858 34.5817C47.6838 33.8378 50.0331 31.2273 50.0331 28.7509C50.0331 26.2746 47.6838 24.8701 44.7858 25.614C41.8878 26.3579 39.5386 28.9684 39.5386 31.4448C39.5386 33.9212 41.8878 35.3256 44.7858 34.5817Z'
        fill='#FF9900'
      />
      <path
        d='M44.787 34.0741C47.3642 33.4126 49.4534 31.091 49.4534 28.8887C49.4534 26.6865 47.3642 25.4375 44.787 26.099C42.2098 26.7606 40.1206 29.0822 40.1206 31.2844C40.1206 33.4867 42.2098 34.7357 44.787 34.0741Z'
        fill='url(#paint6_linear_10790_2687)'
      />
      <path
        d='M46.5378 30.8848C45.3796 30.356 44.3872 31.5873 44.2151 32.5787C43.7904 33.988 44.6644 35.3418 44.7924 36.7392C45.3384 39.185 45.8844 41.6219 46.417 44.063C47.9209 44.8485 49.7296 45.9673 51.4766 45.2557C52.2453 44.9271 52.7723 43.9014 52.157 43.2165C50.6103 39.4516 49.3418 35.5665 47.6247 31.8815C47.3555 31.4697 47.0044 31.0927 46.5378 30.8848Z'
        fill='black'
      />
      <path
        d='M47.4976 32.7761L51.894 44.0705C51.894 44.0705 51.4859 45.1184 50.0962 44.9497C48.7065 44.781 46.9156 43.7203 46.9156 43.7203L44.6045 33.3373C44.6045 33.3373 44.9291 31.3787 45.8759 31.2998C46.8227 31.2207 47.4976 32.7761 47.4976 32.7761Z'
        fill='#FF9900'
      />
      <path
        d='M46.0743 31.872C45.4829 31.7403 45.3076 32.6758 45.2441 33.0791C45.0557 34.2769 45.7762 35.4112 45.9006 36.602C46.4042 38.8589 46.9079 41.116 47.4115 43.3729C48.5173 43.8774 50.0151 44.5443 51.2508 43.9572C49.1708 39.2148 48.103 35.5258 46.6554 32.4248C46.5454 32.1892 46.3454 31.9318 46.0743 31.8714L46.0743 31.872Z'
        fill='url(#paint7_linear_10790_2687)'
      />
      <path
        d='M50.8925 40.3314C47.1258 40.4224 44.0416 44.212 44.7257 47.9668C45.1775 51.6663 49.117 54.3724 52.7023 53.4214C56.3291 52.6929 58.7079 48.5074 57.4961 44.9676C56.6422 42.1384 53.8407 40.1532 50.8925 40.3314Z'
        fill='black'
      />
      <path
        d='M51.2249 52.9739C54.5259 52.9739 57.2019 50.2742 57.2019 46.944C57.2019 43.6138 54.5259 40.9141 51.2249 40.9141C47.9238 40.9141 45.2478 43.6138 45.2478 46.944C45.2478 50.2742 47.9238 52.9739 51.2249 52.9739Z'
        fill='#FF9900'
      />
      <path
        d='M51.2214 52.2956C54.1569 52.2956 56.5366 49.8947 56.5366 46.933C56.5366 43.9713 54.1569 41.5703 51.2214 41.5703C48.2859 41.5703 45.9062 43.9713 45.9062 46.933C45.9062 49.8947 48.2859 52.2956 51.2214 52.2956Z'
        fill='url(#paint8_linear_10790_2687)'
      />
      <path
        d='M49.4453 46.4409C50.0585 47.7627 52.0265 47.7165 53.0341 47.1639C54.6318 46.5266 54.9868 44.8609 56.0657 43.7776C57.6578 41.6171 59.2421 39.463 60.8425 37.3168C60.1308 35.5313 59.4241 33.2619 57.2063 32.3243C56.2173 31.9227 54.8538 32.2075 54.8335 33.1925C53.0329 37.0985 50.8735 40.86 49.2982 44.85C49.1933 45.3594 49.1938 45.912 49.4453 46.4409Z'
        fill='black'
      />
      <path
        d='M50.182 44.3195L55.8075 32.8019C55.8075 32.8019 57.0807 32.4038 58.2154 33.6638C59.3501 34.9239 60.0905 37.1379 60.0905 37.1379L53.3256 46.3038C53.3256 46.3038 51.3495 47.4078 50.4102 46.6851C49.4709 45.9625 50.1819 44.3193 50.1819 44.3193L50.182 44.3195Z'
        fill='#FF9900'
      />
      <path
        d='M50.7155 46.1261C51.1471 46.7041 52.1098 46.1935 52.5135 45.9634C53.7128 45.2799 54.021 43.894 54.9264 42.9583C56.3957 40.9648 57.865 38.9713 59.3344 36.9779C58.7485 35.7161 57.9408 34.0185 56.3005 33.4141C54.1537 38.4424 51.9774 41.9019 50.6546 45.2611C50.5541 45.5163 50.5177 45.8609 50.7156 46.1259L50.7155 46.1261Z'
        fill='url(#paint9_linear_10790_2687)'
      />
      <path
        d='M62.5688 27.5691C61.8155 28.0776 61.1313 28.6215 60.6903 29.1587C60.1469 29.8206 60.5282 31.5775 63.0658 31.4567C66.3049 31.3024 67.6652 30.0829 69.357 27.7869C69.0039 23.535 63.9343 26.6334 62.5688 27.5691Z'
        fill='url(#paint10_linear_10790_2687)'
      />
      <path
        d='M63.8875 18.43C62.1493 18.4757 60.9443 21.1796 59.0096 22.4938C56.8747 23.9439 55.5429 24.529 54.6567 27.0264C53.7706 29.5238 56.3485 33.6103 56.3485 33.6103C56.3485 33.6103 54.8204 32.1426 54.4981 30.914C54.4981 30.914 53.0883 32.2811 53.3703 33.8922C53.6523 35.5035 54.8577 37.0351 57.3954 37.72C59.9331 38.4048 61.5448 37.6782 62.8338 36.3489C63.4138 35.7508 63.5847 34.8836 63.5986 34.1108C62.8569 34.076 62.1429 33.6068 61.794 32.9654L59.8555 33.6914C59.8555 33.6914 59.8535 33.6119 60.941 33.0077C61.1727 32.879 61.4028 32.712 61.6178 32.5072C61.553 32.2332 61.5541 31.943 61.6424 31.6507C61.8261 31.2952 62.0489 30.8471 62.3932 30.6039C61.7564 30.0567 61.414 29.1737 61.8187 28.387C62.0519 28.0963 62.3028 27.8241 62.5694 27.5693C62.1137 25.9361 61.2229 25.7578 61.2229 25.7578C61.2229 25.7578 64.1624 23.2599 65.0082 22.5751C65.8541 21.8903 66.4986 19.112 64.4443 18.5078C64.2517 18.4511 64.0673 18.4255 63.8874 18.4302L63.8875 18.43Z'
        fill='url(#paint11_linear_10790_2687)'
      />
      <path
        d='M68.928 29.5001C67.3568 31.2447 64.9584 32.2784 62.5908 31.9249C62.2601 31.9223 61.9346 31.8279 61.6427 31.6641C61.4274 31.8743 61.2372 32.0883 61.0823 32.2986C60.625 32.9193 60.9488 34.5654 63.0842 34.4521C65.8099 34.3074 67.2884 33.0601 68.712 30.9068C68.9539 30.5409 68.8749 29.8626 68.9279 29.5L68.928 29.5001Z'
        fill='url(#paint12_linear_10790_2687)'
      />
      <path
        d='M67.4832 49.0978L64.2963 9.7436C64.3184 9.60718 64.2925 6.80318 64.0416 5.88262C64.1078 4.73345 64.2185 2.69148 63.877 1.83623C63.3943 0.618145 58.4546 0.618144 57.4154 2.58965C57.1136 4.70065 57.759 6.02509 57.7486 6.58338C57.6855 6.97313 57.7945 9.51061 57.968 10.5386C58.0503 11.5119 60.9234 49.8353 60.9234 49.8353C60.9234 49.8353 63.2843 54.0057 64.0168 58.0041C64.6837 57.3108 65.4358 56.5001 65.7088 56.3237C65.8389 55.0212 66.5187 51.3947 67.4832 49.0988L67.4832 49.0978Z'
        stroke='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M61.248 49.6762C61.248 49.6762 63.4453 53.5049 64.188 57.3018C64.3811 57.33 65.1697 56.275 65.3862 56.1977C65.5779 53.5565 67.129 48.9882 67.129 48.9882L65.9461 41.2734L61.3297 41.4874L61.248 49.6762Z'
        fill='url(#paint13_linear_10790_2687)'
        stroke='black'
        strokeWidth='0.648478'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M58.3411 10.4603L61.2733 49.6531C61.2733 49.6531 62.2329 39.5292 64.1972 48.8868C64.8862 39.199 67.0591 48.7503 67.1256 49.081C67.0662 47.4715 63.9363 9.74716 63.9363 9.74716C63.9363 9.74716 60.5402 8.73717 58.3411 10.4609V10.4603Z'
        fill='url(#paint14_linear_10790_2687)'
        stroke='black'
        strokeWidth='0.648478'
      />
      <path
        d='M59.7732 10.1484C59.9149 11.0199 62.2211 42.448 62.4971 44.5853'
        stroke='black'
        strokeOpacity='0.18333'
        strokeWidth='1.82379'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M63.4272 54.5088C64.2678 54.6449 65.1311 53.9857 65.7572 53.875C65.6292 54.4906 65.3359 56.0836 65.4143 56.1669C64.9784 56.4569 64.4851 57.2326 64.1882 57.2764C64.0178 56.4074 63.8685 55.8883 63.4272 54.5088Z'
        fill='black'
        stroke='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M63.6961 5.86838C60.6897 4.92151 58.2972 6.23395 58.104 6.56264C57.9976 6.72541 57.4154 2.91132 57.8488 2.58154C58.1146 1.80464 61.2853 0.378272 63.4309 1.82566C63.9481 2.08942 63.7334 5.51446 63.6961 5.86838Z'
        fill='url(#paint15_radial_10790_2687)'
        stroke='black'
        strokeWidth='0.648478'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M63.9329 9.77355C60.9264 8.82668 58.5339 10.1391 58.3407 10.4678C58.2344 10.6306 58.0181 6.65577 58.0855 6.48671C58.1529 6.31763 61.5465 4.62733 63.6676 5.73083C63.8964 6.78782 63.9702 9.41963 63.9329 9.77355Z'
        fill='url(#paint16_linear_10790_2687)'
        stroke='black'
        strokeWidth='0.648478'
      />
      <path
        d='M58.3613 8.96571C61.1104 7.50593 63.6241 8.29641 63.7183 8.32581'
        stroke='white'
        strokeWidth='0.4'
        strokeLinecap='round'
      />
      <path
        d='M58.2542 7.17347C61.1183 5.78891 63.4871 6.51348 63.6226 6.54957'
        stroke='white'
        strokeWidth='0.4'
        strokeLinecap='round'
      />
      <path
        d='M62.5278 9.85156C62.6695 10.723 64.9757 42.1511 65.2517 44.2884'
        stroke='black'
        strokeOpacity='0.18333'
        strokeWidth='1.82379'
        strokeLinecap='round'
      />
      <path
        d='M6.00724 54.0115C2.83853 54.7208 0.243895 58.0462 0.81944 60.7034C1.19948 63.3595 4.51362 64.6872 7.52962 63.3735C10.5807 62.2171 12.5818 58.7194 11.5624 56.3109C10.844 54.3663 8.48728 53.3773 6.00713 54.0114L6.00724 54.0115Z'
        fill='black'
      />
      <path
        d='M6.28536 63.3129C9.06227 62.7502 11.3134 60.2996 11.3134 57.8392C11.3134 55.3788 9.06227 53.8404 6.28536 54.4031C3.50845 54.9657 1.25732 57.4164 1.25732 59.8768C1.25732 62.3372 3.50845 63.8756 6.28536 63.3129Z'
        fill='#FF9900'
      />
      <path
        d='M6.28548 62.8142C8.75503 62.3138 10.757 60.1345 10.757 57.9465C10.757 55.7585 8.75503 54.3905 6.28548 54.8908C3.81593 55.3912 1.81396 57.5706 1.81396 59.7586C1.81396 61.9465 3.81593 63.3146 6.28548 62.8142Z'
        fill='url(#paint17_linear_10790_2687)'
      />
      <path
        d='M5.25504 58.6024C4.41694 59.5836 5.17114 61.1285 5.98194 61.7217C7.07588 62.7516 8.54285 62.4102 9.80583 62.8615C12.1209 63.3171 14.428 63.769 16.7346 64.2366C17.9091 63.0037 19.474 61.5938 19.419 59.4826C19.3812 58.5473 18.6557 57.5715 17.8574 57.9238C14.0646 57.9557 10.2572 57.6485 6.47843 57.8906C6.03114 57.9979 5.58751 58.2049 5.25448 58.6023L5.25504 58.6024Z'
        fill='black'
      />
      <path
        d='M7.22064 58.4062L18.5195 58.5635C18.5195 58.5635 19.303 59.4252 18.7046 60.7974C18.1061 62.1695 16.5978 63.5853 16.5978 63.5853L6.77229 61.644C6.77229 61.644 5.16577 60.4883 5.40398 59.4725C5.64213 58.4565 7.22064 58.4062 7.22064 58.4062Z'
        fill='#FF9900'
      />
      <path
        d='M5.96602 59.5073C5.65904 60.0662 6.41983 60.6394 6.75175 60.8737C7.73751 61.57 8.9628 61.2963 10.0441 61.6649C12.1803 62.0856 14.3165 62.5062 16.4528 62.9269C17.2526 61.9898 18.3216 60.7137 18.2094 59.1854C13.3892 59.3622 9.81817 58.9286 6.63874 59.1353C6.39711 59.151 6.10718 59.251 5.96646 59.5072L5.96602 59.5073Z'
        fill='url(#paint18_linear_10790_2687)'
      />
      <path
        d='M36.2123 47.1566C36.1783 47.1555 36.1433 47.1571 36.109 47.1594C34.4518 47.5325 33.2399 48.7734 31.8875 49.6787C30.7242 50.5913 29.523 51.513 28.1417 52.0924C28.4255 51.2067 28.5811 50.1679 27.8285 49.4787C27.4605 49.1809 26.9639 49.0574 26.4843 49.0732C24.8645 49.2373 23.8579 50.6265 23.0221 51.7841C22.4677 52.5944 22.0367 53.1706 21.5911 54.0355C20.7769 54.3373 19.9408 54.9124 19.5292 55.6553C18.0085 54.4632 15.6583 54.9262 14.7445 57.2281C14.0508 58.8633 14.2941 60.6898 14.3545 62.4139C14.4977 64.0253 15.0538 65.8883 16.6765 66.7053C17.5826 67.1145 18.6927 66.7467 19.2288 65.972C19.5665 65.6511 19.8224 65.5128 19.9113 65.185C21.3004 67.0126 24.642 67.3043 26.6015 65.8171C27.4013 66.6439 28.5236 66.5221 29.9701 66.0498C32.4655 65.1233 34.1001 62.7837 34.6465 60.3752C34.7778 59.6319 34.6667 58.7377 34.1426 58.3852C34.7757 56.5086 33.7665 55.7698 33.448 55.5084C34.7273 54.8693 36.9515 53.0159 37.8961 51.5202C38.5212 50.1364 38.1211 48.3364 36.8769 47.3788C36.6807 47.254 36.4509 47.1644 36.2123 47.1566Z'
        fill='black'
      />
      <path
        d='M19.1297 58.9388C19.1297 58.9388 19.1106 56.6725 20.9675 55.117C22.8244 53.5616 27.5173 53.1171 29.6443 51.7522C31.7714 50.3873 35.2488 47.2763 36.3291 47.5303C37.4095 47.7842 38.2536 50.0063 37.5445 51.403C36.8355 52.7998 33.0036 55.2122 33.0036 55.2122C29.6274 54.7043 27.7873 55.7519 27.7873 55.7519C27.7873 55.7519 34.506 53.879 33.7294 58.1168C30.8259 57.3549 28.2263 59.0849 28.2263 59.0849C28.2263 59.0849 33.2437 57.2562 34.2021 59.4341C34.6073 60.3547 33.5606 62.8625 32.0414 64.3227C30.5547 65.7516 29.0262 66.0354 28.1587 66.0051C27.2472 65.9734 27.0108 65.5607 27.0108 65.5607C27.0108 65.5607 29.678 64.0053 29.9481 62.0054C29.9481 62.0054 26.9432 66.8305 23.0269 66.1321C19.1105 65.4337 19.1098 62.1138 19.1098 62.1138C18.7722 63.7962 19.5157 64.8305 19.5157 64.8305C19.5157 64.8305 18.8742 66.3543 17.7263 66.513C16.5785 66.6717 14.8566 65.4337 14.6878 61.8466C14.5161 58.1991 14.8566 56.7675 16.4097 56.0691C17.9628 55.3708 19.347 56.3231 19.347 56.3231C18.908 58.0055 19.1297 58.9386 19.1297 58.9386L19.1297 58.9388Z'
        fill='url(#paint19_linear_10790_2687)'
      />
      <path
        d='M26.587 49.4377C24.7695 49.4138 23.1352 52.1536 22.2805 53.8126C23.7912 53.1143 25.3787 53.018 26.9593 52.4985C27.2051 52.4385 27.4456 52.3671 27.6801 52.2847C28.0864 51.1871 28.38 49.5908 26.7082 49.446C26.6681 49.4425 26.6271 49.4382 26.587 49.4377Z'
        fill='url(#paint20_linear_10790_2687)'
      />
      <path
        d='M30.096 18.5817C29.9849 18.5702 29.8745 18.5621 29.7638 18.5557C28.1199 18.5409 26.2608 18.6766 24.7632 19.6393C22.9988 20.2143 20.7072 21.1221 19.918 23.0603C19.4267 24.6718 21.2153 25.7657 22.4748 26.0936C25.9712 27.1367 29.9846 26.5882 33.4322 24.7684C34.6464 24.1312 36.5068 22.7303 36.0517 21.2328C35.5505 19.5836 33.1567 19.1111 31.6808 18.9117C31.6111 18.9091 31.5532 18.92 31.5018 18.9366C31.0673 18.7365 30.5815 18.632 30.0962 18.5818L30.096 18.5817Z'
        fill='black'
      />
      <path
        d='M27.7173 22.7468C29.9776 22.5628 31.9467 21.6104 32.1155 20.6197C32.2842 19.6289 30.5887 18.9749 28.3284 19.159C26.0682 19.343 24.099 20.2954 23.9303 21.2861C23.7615 22.2769 25.4571 22.9308 27.7173 22.7468Z'
        fill='#FF9900'
      />
      <path
        d='M32.223 19.5859C32.5824 19.8632 32.7611 20.2053 32.6947 20.5947C32.4974 21.7529 30.242 22.8703 27.6581 23.0908C25.0741 23.3113 23.1387 22.5498 23.336 21.3916C23.3848 21.1052 23.5589 20.8186 23.833 20.5502C22.0986 21.2925 20.9005 22.3035 20.7257 23.3298C20.4179 25.1369 23.4 26.3191 27.3891 25.9711C31.3782 25.6232 34.8635 23.8758 35.1713 22.0688C35.3714 20.8938 34.1779 19.9838 32.223 19.5859Z'
        fill='#FF9900'
      />
      <path
        d='M27.7744 22.4141C29.6245 22.2634 31.2363 21.4839 31.3745 20.6729C31.5126 19.8619 30.1247 19.3266 28.2746 19.4772C26.4244 19.6279 24.8126 20.4074 24.6745 21.2184C24.5363 22.0294 25.9242 22.5647 27.7744 22.4141Z'
        fill='url(#paint21_linear_10790_2687)'
      />
      <path
        d='M33.2325 20.5391C32.928 22.2114 31.0952 22.8629 29.7674 23.2672C27.6063 23.8754 25.1287 24.0394 23.3178 22.7739C23.0303 22.5098 22.8163 22.1412 22.7774 21.7174C22.0768 22.1254 20.9637 22.9839 21.3583 23.8942C22.281 25.2798 24.1601 25.3051 25.6952 25.4296C28.5109 25.4842 31.615 24.935 34.0319 23.0031C34.6248 22.521 34.908 21.5035 34.2263 21.0858C33.9519 20.8497 33.547 20.5445 33.2326 20.5392L33.2325 20.5391Z'
        fill='url(#paint22_linear_10790_2687)'
      />
      <path
        d='M26.1912 38.314C27.1207 38.314 27.8742 36.4965 27.8742 34.2546C27.8742 32.0127 27.1207 30.1953 26.1912 30.1953C25.2618 30.1953 24.5083 32.0127 24.5083 34.2546C24.5083 36.4965 25.2618 38.314 26.1912 38.314Z'
        fill='black'
      />
      <path
        d='M26.1914 37.7967C27.0026 37.7967 27.6602 36.2105 27.6602 34.2538C27.6602 32.2971 27.0026 30.7109 26.1914 30.7109C25.3803 30.7109 24.7227 32.2971 24.7227 34.2538C24.7227 36.2105 25.3803 37.7967 26.1914 37.7967Z'
        fill='url(#paint23_linear_10790_2687)'
      />
      <path
        d='M25.6765 34.7502C26.0817 34.7502 26.4102 33.9579 26.4102 32.9806C26.4102 32.0032 26.0817 31.2109 25.6765 31.2109C25.2713 31.2109 24.9429 32.0032 24.9429 32.9806C24.9429 33.9579 25.2713 34.7502 25.6765 34.7502Z'
        fill='white'
      />
      <path
        d='M16.0034 35.3979C16.0034 35.3979 15.9362 32.8387 18.2098 32.671C20.4835 32.5032 20.9161 35.4426 20.9161 35.4426C20.9161 35.4426 19.1495 33.3969 17.8762 33.6348C16.6028 33.8728 16.0034 35.398 16.0034 35.398V35.3979Z'
        fill='black'
      />
      <path
        d='M30.4941 40.7643C30.4941 40.7643 34.8377 37.7879 35.1796 34.9823C34.6384 34.5551 32.1177 34.5266 32.1177 34.5266C32.1177 34.5266 34.966 32.6467 37.3585 34.0139C39.2516 35.0957 38.4408 37.7736 38.4408 37.7736C38.4408 37.7736 37.7573 36.0647 36.9883 35.8083C35.0799 39.9953 30.4941 40.7643 30.4941 40.7643Z'
        fill='black'
      />
      <path
        d='M68.2201 22.2121C65.8041 22.7721 64.8156 21.4704 63.2652 25.6716C62.9349 26.5184 62.6816 27.3549 62.6245 28.0476C62.5541 28.9011 63.8673 30.1292 65.8855 28.5861C68.4616 26.6165 68.1349 25.0629 68.2201 22.2121C68.3012 22.4809 68.23 21.8807 68.2201 22.2121Z'
        fill='url(#paint24_linear_10790_2687)'
      />
      <path
        d='M63.2652 25.6497C62.9349 26.4965 62.6816 27.3331 62.6245 28.0258C62.5541 28.8793 63.8673 30.1074 65.8855 28.5643C68.4616 26.5947 69.6626 22.7776 67.5887 21.5716C65.876 20.5756 63.6765 24.5877 63.2651 25.6499L63.2652 25.6497Z'
        fill='url(#paint25_linear_10790_2687)'
        stroke='black'
      />
      <path
        d='M63.8875 18.4303C62.1493 18.476 60.8269 20.7494 58.8922 22.0635C56.7572 23.5135 54.9949 24.7641 54.1087 27.2615C53.2225 29.7589 56.3485 33.6104 56.3485 33.6104C56.3485 33.6104 54.8204 32.1428 54.4981 30.9142C54.4981 30.9142 53.0883 32.2813 53.3703 33.8924C53.6523 35.5037 54.8577 37.0353 57.3954 37.7201C58.4081 38.121 59.8749 37.954 59.8749 37.954C59.8556 33.6915 59.3859 30.749 59.3049 27.8717C59.2501 25.9244 64.3974 23.4556 65.4782 22.4185C66.2635 21.665 66.4988 19.112 64.4445 18.5078C64.2519 18.4511 64.0675 18.4255 63.8877 18.4302L63.8875 18.4303Z'
        fill='url(#paint26_linear_10790_2687)'
        stroke='#000300'
        strokeWidth='0.7'
      />
      <defs>
        <linearGradient
          id='paint0_linear_10790_2687'
          x1='27.6144'
          y1='71.2676'
          x2='36.4816'
          y2='69.2179'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#969696' />
          <stop offset='1' stopColor='#5A5A5A' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_10790_2687'
          x1='9.56239'
          y1='42.1511'
          x2='11.2163'
          y2='54.7149'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_10790_2687'
          x1='31.0863'
          y1='58.4594'
          x2='40.7815'
          y2='48.1042'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3366FF' />
          <stop offset='1' stopColor='#00279C' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_10790_2687'
          x1='34.1637'
          y1='46.9293'
          x2='36.1452'
          y2='38.3731'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='#8D5500' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_10790_2687'
          x1='33.565'
          y1='33.059'
          x2='48.4211'
          y2='30.4282'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9CDAFB' />
          <stop offset='1' stopColor='#1AA9F6' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_10790_2687'
          x1='10.0561'
          y1='39.1514'
          x2='19.832'
          y2='27.2865'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#9CDAFB' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_10790_2687'
          x1='45.1539'
          y1='32.2426'
          x2='42.4862'
          y2='27.6876'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_10790_2687'
          x1='49.1659'
          y1='43.7929'
          x2='45.7706'
          y2='30.9497'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_10790_2687'
          x1='51.6393'
          y1='49.9591'
          x2='48.8629'
          y2='42.8107'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_10790_2687'
          x1='58.0779'
          y1='35.2411'
          x2='51.2249'
          y2='47.586'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_10790_2687'
          x1='63.5206'
          y1='29.8893'
          x2='65.7549'
          y2='27.3922'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_10790_2687'
          x1='56.9021'
          y1='29.6556'
          x2='62.2853'
          y2='32.9184'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_10790_2687'
          x1='62.6237'
          y1='33.7112'
          x2='64.5467'
          y2='32.1807'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_10790_2687'
          x1='63.8455'
          y1='49.0319'
          x2='68.5178'
          y2='48.8734'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFECD5' />
          <stop offset='1' stopColor='#AF9143' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_10790_2687'
          x1='61.2912'
          y1='30.0354'
          x2='65.5834'
          y2='29.8235'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#EFC65C' />
          <stop offset='1' stopColor='#AF9143' />
        </linearGradient>
        <radialGradient
          id='paint15_radial_10790_2687'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(59.0936 3.66256) rotate(-80.8008) scale(2.96377 3.21965)'
        >
          <stop stopColor='#FFE8DA' />
          <stop offset='1' stopColor='#FFC5A5' />
        </radialGradient>
        <linearGradient
          id='paint16_linear_10790_2687'
          x1='64.0286'
          y1='8.4632'
          x2='58.3055'
          y2='8.51375'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFF48F' />
          <stop offset='1' stopColor='#FFFDE5' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_10790_2687'
          x1='6.63699'
          y1='61.0169'
          x2='4.08658'
          y2='56.3259'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_10790_2687'
          x1='17.3875'
          y1='61.2856'
          x2='4.99176'
          y2='60.2773'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_10790_2687'
          x1='24.1209'
          y1='60.544'
          x2='24.8311'
          y2='66.1428'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_10790_2687'
          x1='24.9603'
          y1='51.192'
          x2='24.9394'
          y2='53.7634'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_10790_2687'
          x1='30.6345'
          y1='20.8047'
          x2='25.4442'
          y2='19.7965'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_10790_2687'
          x1='30.7422'
          y1='24.3427'
          x2='21.7623'
          y2='22.5682'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF9900' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_10790_2687'
          x1='26.3892'
          y1='36.5671'
          x2='26.0654'
          y2='30.1912'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0000FF' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_10790_2687'
          x1='65.3679'
          y1='27.038'
          x2='65.7848'
          y2='23.7133'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_10790_2687'
          x1='65.3677'
          y1='27.0165'
          x2='65.7846'
          y2='23.6918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_10790_2687'
          x1='56.7453'
          y1='29.6953'
          x2='60.368'
          y2='30.6867'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#CECECE' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default IconUser
